import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";


import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseAllocationBasicDetail from "./warehouseAllocationComponents/WarehouseAllocationBasicDetail";

import {
  useGetWarehouseAllocationDetailQuery} from "store/services/warehouseAllocationApi";

import { WarehouseAllocationDetailContext, useWarehouseAllocationDetailContext } from "contexts/WarehouseAllocationDetailContext";



const WarehouseAllocationDetailScreen = () => {
  const { id } = useParams();
 
  const breadcrumbs = [
    { title: "Warehouse Allocations", path: "/app/crm/warehouse-allocation/list" },
    { title: "Allocation Detail" },
  ];

  // RTK Query
  const {
    data: allocationDetail,
    isLoading: loadingAllocation,
    error,
  } = useGetWarehouseAllocationDetailQuery(id);

  return (
    <WarehouseAllocationDetailContext.Provider
      value={{ allocationDetail, loadingAllocation }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingAllocation}
        toggleKey="WAREHOUSE_ALLOCATION_DETAIL"
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <WarehouseAllocationBasicDetail />
                 </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </WarehouseAllocationDetailContext.Provider>
  );
};

export default WarehouseAllocationDetailScreen;

const PageActions = () => {
  const { allocationDetail } = useWarehouseAllocationDetailContext();

  return (
    <div className="flex items-center gap-4">
        <Link to={`/app/crm/warehouse-allocation/${allocationDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
